module.exports = __webpack_public_path__ + "static/media/tools.58f3159d.svg";